import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import '../../commonComp/headrAgent/headeragent.scss';
import warningiba from '../../../../asset/images/ibaimages/warning-iba.svg'
import successIba from '../../../../asset/images/iba-success.svg'
import { toast } from 'react-toastify';
import { IBA_Admin_Section } from '../../../../Configuration/API_URL';
import { axiosInstance0 } from '../../../../CommonMethhods/axiosInstance';


const HeaderAgent = ({ agentsDetails, refreshAgentDetails, selectedAgent, refreshAgentList, setSelectedAgent }) => {
  const [filterModal, setFilterModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [activateModal, setActivateModal] = useState(false);
  const [deactSuccModal, setDeactSuccModal] = useState(false);
  const [actSuccModal, setActSuccModal] = useState(false);
  const getRole = localStorage.getItem("IbaRole");
  const [teamLeadList, setTeamLeadList] = useState([]);

  const schema = Yup.object().shape({
    userId: Yup.string().required('User ID is required'),
    phone: Yup.string()
      .matches(/^(\d{10}|\*{6}\d{4})$/, 'Phone number must be 10 digits')
      .required('Phone number is required'),
    tierName: Yup.string().notRequired(''),
    teamLead: Yup.string().required('Lead is required'),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const openEditModal = () => {
    setFilterModal(true);
    reset({
      userId: agentsDetails?.Personal?.sapCode || '',
      phone: agentsDetails?.Personal?.PhoneNumber || '',
      tierName: agentsDetails?.Personal?.TierName || '',
      // teamLead: agentsDetails?.Personal?.TeamLeader || '',
    });
  };

  const saveProfileDetails = async (data) => {
    const payload = {
      teamLeadCode: data?.teamLead,
      sapcode: data?.userId
    }
    try {
      const response = await axiosInstance0.post(
        IBA_Admin_Section.updateProfile,
        payload,
      );
      const data = await response?.data;
      if (data.status === 0) {
        if (data?.data?.flag === "success") {
          toast.success(data?.message)
          setFilterModal(false);

          refreshAgentDetails?.();
        }
        console.log(data, "update");
      } else {
        toast.error(data?.message)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = async (data) => {
    console.log(data, "submitData");
    saveProfileDetails(data)
  };

  const handleDeactivate = async () => {
    const payload = {
      IsActive: selectedAgent?.status === "Active" ? "0" : "1",
      sapcode: agentsDetails?.Personal?.sapCode
    }
    try {
      const response = await axiosInstance0.post(
        IBA_Admin_Section.deactivateAgent,
        payload,
      );
      const data = await response?.data;
      if (data.status === 0) {

        if (data?.data?.flag === "success") {
          setSelectedAgent(prev => ({
            ...prev,
            status: prev?.status === "Active" ? "Deactive" : "Active",
          }));
          // refreshAgentList?.();
          // refreshAgentDetails?.();
          if (selectedAgent?.status === "Active") {
            setDeactivateModal(false);
            setDeactSuccModal(true);
          } else {
            setActivateModal(false);
            setActSuccModal(true);

          }
        } else {
          toast.error(data?.message)
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getInitials = (name = "") => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    const firstInitial = words[0]?.charAt(0).toUpperCase() || "";
    const lastInitial = words.length > 1 ? words[words.length - 1].charAt(0).toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  const getTeamLeaderList = async () => {
    try {
      const response = await axiosInstance0.get(
        IBA_Admin_Section.getTeamLeaderData,

      );
      const data = await response?.data;
      if (data.status === 0) {
        setTeamLeadList(data)
        console.log(data, "update");
      } else {
        toast.error(data?.message)
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getTeamLeaderList()
  }, []);

  useEffect(() => {
    if (
      filterModal &&
      agentsDetails?.Personal?.TeamLeaderId &&
      teamLeadList?.data?.length > 0
    ) {
      setValue(
        'teamLead',
        agentsDetails.Personal.TeamLeaderId,
        { shouldValidate: true }
      );
    }
  }, [filterModal, agentsDetails, teamLeadList, setValue]);


  return (
    <div className="agent-info-card">
      <div className="left">
        {agentsDetails?.Personal?.AgentName ?
          <div className="avatar-text">
            {getInitials(agentsDetails?.Personal?.AgentName)}
          </div>
          :
          <span className='no-icon'>N/A</span>}
        {/* <img src={agentsDetails.avatar} alt="avatar" className="avatar" /> */}
        <div className="agent-details">
          <div className="name">{agentsDetails?.Personal?.AgentName}</div>
          <div className="role">Agent</div>
        </div>
      </div>
    {getRole === "IBA Admin" &&
      <div className="middle">
        <div><strong>User ID:</strong> <span className="link header-sec">{agentsDetails?.Personal?.sapCode}</span></div>
        <div><strong>Phone Number:</strong> <span className="link header-sec">{agentsDetails?.Personal?.PhoneNumber}</span></div>
        <div><strong>Team Lead Name:</strong> <span className="link header-sec">{agentsDetails?.Personal?.TeamLeader}</span></div>
        <div><strong>Tier Name:</strong> <span className="link header-sec">{agentsDetails?.Personal?.TierName}</span></div>
      </div>
      // : getRole === "IBA" &&
      // <div className="middle agent-middle">
      //   <div><strong>User ID:</strong> <span className="link header-sec">{agentsDetails?.Personal?.sapCode}</span></div>
      //   <div><strong>Phone Number:</strong> <span className="link header-sec">{agentsDetails?.Personal?.PhoneNumber}</span></div>
      //   <div><strong>Password:</strong> <span className="link header-sec">{agentsDetails?.Personal?.TeamLeader}</span></div>
      //   <div><strong>Team Lead:</strong> <span className="link header-sec">{agentsDetails?.Personal?.TierName}</span></div>
      // </div>
    }
      
    {getRole === "IBA Admin" &&
      <div className="right">
        {selectedAgent?.status === "Active" ?
          <button className="btn deactivate" onClick={() => setDeactivateModal(true)}>Deactivate</button>
          :
          <button className="btn deactivate" onClick={() => setActivateModal(true)}>Activate</button>
        }

        <button className="btn edit" onClick={openEditModal}>Edit</button>
      </div>
    }

      <Modal
        show={filterModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-edit-modal"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setFilterModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="profile-modal-content">
            <div className="iput-wrapp">
              <div className="profile-header">Profile</div>

              <div className="profile-form-row">
                <div className="form-group">
                  <label>User ID:</label>
                  <input
                    type="text"
                    {...register('userId')}
                    disabled />
                  {errors.userId && <p className="error">{errors.userId.message}</p>}
                </div>

                <div className="form-group">
                  <label>Phone Number:</label>
                  <input type="text" {...register('phone')} disabled />
                  {errors.phone && <p className="error">{errors.phone.message}</p>}
                </div>
              </div>

              <div className="profile-form-row">
                <div className="form-group">
                  <label>Team Lead SAP Code:</label>
                  <select
                    {...register('teamLead')}
                  >
                    <option value="">Select Teamlead Code</option>
                    {teamLeadList?.data?.length > 0 &&
                      teamLeadList?.data.map((item) => (
                        <option key={item?.Id} value={item?.Id}>{item?.TeamLeader}</option>
                      ))
                    }
                  </select>

                  {errors.teamLead && <p className="error">{errors.teamLead.message}</p>}
                </div>

                <div className="form-group">
                  <label>Tier Name:</label>
                  <input type="text" {...register('tierName')} disabled />
                  {errors.tierName && <p className="error">{errors.tierName.message}</p>}
                </div>
              </div>
            </div>

            <div className="profile-footer-iba">
              <Button className="cancel-btn-iba" onClick={() => setFilterModal(false)}>
                Cancel
              </Button>
              <Button type="submit" className="save-btn-iba">
                Save
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={activateModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setActivateModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="profile-modal-content">
            <div className='iba-worning'>
              <img src={warningiba} alt="" height={"70px"} width={"70px"} />
              <span className='conf-text'>Are you sure you want to Activate?</span>
            </div>
            <div className="profile-footer-iba">
              <Button className="cancel-btn-iba" onClick={() => setActivateModal(false)} >
                Cancel
              </Button>
              <Button type="submit" className="save-btn-iba" onClick={handleDeactivate}>
                Confirm
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={deactivateModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setDeactivateModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="profile-modal-content">
            <div className='iba-worning'>
              <img src={warningiba} alt="" height={"70px"} width={"70px"} />
              <span className='conf-text'>Are you sure you want to Deactivate?</span>
            </div>
            <div className="profile-footer-iba">
              <Button className="cancel-btn-iba" onClick={() => setDeactivateModal(false)} >
                Cancel
              </Button>
              <Button type="submit" className="save-btn-iba" onClick={handleDeactivate}>
                Confirm
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* deactivation success modal */}

      <Modal
        show={deactSuccModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setDeactSuccModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <div className="profile-modal-content">
            <div className='iba-success'>
              <img src={successIba} alt="" height={"70px"} width={"70px"} />
              <span className='conf-text'>Account Deactivated Successfully!</span>
            </div>

            <div className="profile-footer-iba">
              <Button type="submit" className="save-btn-iba" onClick={() => setDeactSuccModal(false)}>
                OKAY
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={actSuccModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setActSuccModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <div className="profile-modal-content">
            <div className='iba-success'>
              <img src={successIba} alt="" height={"70px"} width={"70px"} />
              <span className='conf-text'>Account Activated Successfully!</span>
            </div>

            <div className="profile-footer-iba">
              <Button type="submit" className="save-btn-iba" onClick={() => setActSuccModal(false)}>
                OKAY
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HeaderAgent;
